import { Suspense } from "react";
import { Helmet } from "react-helmet";
import { Footer } from "@/components/Footer";
import { AboutFeaturesList } from "@/components/about/AboutFeaturesList";
import { AboutErrorBoundary } from "@/components/about/AboutErrorBoundary";
import { LoadingState } from "@/components/layout/LoadingState";
import { aboutMetadata } from "@/config/about";

const About = () => {
  const structuredData = {
    "@context": "https://schema.org",
    "@type": "AboutPage",
    "@id": "https://scienzahealth.com/about#webpage",
    "url": "https://scienzahealth.com/about",
    "name": "About Scienza Health - Leading AI-Powered Cognitive Health Platform",
    "description": "Learn about Scienza Health's mission to transform cognitive healthcare through AI-powered early detection and monitoring solutions.",
    "isPartOf": {
      "@id": "https://scienzahealth.com/#website"
    },
    "about": {
      "@type": "Organization",
      "@id": "https://scienzahealth.com/#organization",
      "name": "Scienza Health",
      "description": "AI-powered cognitive health monitoring and support platform"
    },
    "breadcrumb": {
      "@type": "BreadcrumbList",
      "itemListElement": [{
        "@type": "ListItem",
        "position": 1,
        "name": "Home",
        "item": "https://scienzahealth.com"
      }, {
        "@type": "ListItem",
        "position": 2,
        "name": "About",
        "item": "https://scienzahealth.com/about"
      }]
    },
    "mainEntity": {
      "@type": "Organization",
      "name": "Scienza Health",
      "description": "Advanced AI-powered cognitive health platform specializing in early detection and monitoring",
      "foundingDate": "2023",
      "knowsAbout": [
        "Cognitive Health",
        "Artificial Intelligence",
        "Healthcare Technology",
        "Early Detection",
        "Patient Monitoring"
      ],
      "award": [
        "Microsoft for Startups Member",
        "NVIDIA Inception Program Member"
      ]
    }
  };

  return (
    <>
      <Helmet>
        <title>{aboutMetadata.title}</title>
        <meta name="description" content={aboutMetadata.description} />
        <script type="application/ld+json">
          {JSON.stringify(structuredData)}
        </script>
      </Helmet>
      
      <AboutErrorBoundary>
        <Suspense fallback={<LoadingState />}>
          <AboutFeaturesList />
        </Suspense>
        <Footer />
      </AboutErrorBoundary>
    </>
  );
};

export default About;